import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { useTimeFilterContext } from "../../../../../context/TimeFilterContext/v3/context/TimeFilterContext/TimeFilterContext.js";
import { useTimeFilterItems } from "../../../hooks/v3/components/PreferredTime/hooks/use-time-filter-items.js";
import PreferredTime from "./PreferredTime.js";
const PreferredTimeContainer = ({
  labels: externalLabels,
  onPreferredTimeClick,
  onPreferredTimeFilterClick,
  ...rest
}) => {
  const { getLabel, getFormattedLabel } = useIntl();
  const [, { options }] = useTimeFilterContext();
  const [, { noPreferenceItem, items: timeFilterItems, activeItem }] = useTimeFilterItems({
    allowSingleFilter: true
  });
  const [openPreferredTimePopup, setOpenPreferredTimePopup] = React.useState(false);
  const withPreferredTimeFilters = options.length > 0;
  const labels = React.useMemo(
    () => ({
      title: externalLabels?.title ?? getLabel("appointments.component.preferredTime.title"),
      preferredTime: externalLabels?.preferredTime ?? getLabel("appointments.component.preferredTime.preferredTime")
    }),
    [getLabel, externalLabels]
  );
  const preferredTimeFilterItems = React.useMemo(
    () => [noPreferenceItem, ...timeFilterItems].map((item) => ({
      ...item,
      onClick: () => {
        setOpenPreferredTimePopup(false);
        onPreferredTimeFilterClick?.(item);
        item.onClick();
      }
    })),
    [noPreferenceItem, timeFilterItems, onPreferredTimeFilterClick]
  );
  const preferredTimeFilter = React.useMemo(() => {
    if (!activeItem) {
      return;
    }
    return {
      label: activeItem.label,
      ariaLabels: {
        inactive: getFormattedLabel("appointments.component.quickSelectFilter.inactive", {
          labelData: {
            description: activeItem.label
          }
        }),
        active: getFormattedLabel("appointments.component.quickSelectFilter.active", {
          labelData: {
            description: activeItem.label
          }
        })
      },
      active: activeItem.active,
      onClick: activeItem.onClick
    };
  }, [getFormattedLabel, activeItem]);
  const onClickPreferredTime = React.useCallback(() => {
    onPreferredTimeClick?.();
    setOpenPreferredTimePopup(true);
  }, [onPreferredTimeClick]);
  const onPreferredTimePopupClose = React.useCallback(() => setOpenPreferredTimePopup(false), []);
  return /* @__PURE__ */ React.createElement(
    PreferredTime,
    {
      ...rest,
      labels,
      onClickPreferredTime,
      withPreferredTimeFilters,
      openPreferredTimePopup,
      onPreferredTimePopupClose,
      preferredTimeFilterItems,
      preferredTimeFilter
    }
  );
};
export {
  PreferredTimeContainer as default
};
//# sourceMappingURL=PreferredTimeContainer.js.map
